import Box from "@mui/material/Box";
import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import TabMenu from "../../components/TabMenu.js";

export default function Plots({ locales }) {
  const tabButtons = useMemo(
    () => [
      { label: locales["plots.plots.title"], route: "plots" },
      { label: locales["plots.characters.title"], route: "characters" },
      { label: locales["plots.events.title"], route: "events" },
    ],
    [locales]
  );

  return (
    <>
      <TabMenu tabButtons={tabButtons} />
      <Box>
        <Outlet />
      </Box>
    </>
  );
}
